module.exports = "mat-card {\n  font-size: 2pem;\n  margin: 300px auto; }\n\nbutton mat-progress-spinner {\n  float: left;\n  padding-right: 8px;\n  padding-top: 8px; }\n\n@media only screen and (-webkit-min-device-pixel-ratio: 2), only screen and (min--moz-device-pixel-ratio: 2), only screen and (-o-min-device-pixel-ratio: 2 / 1), only screen and (min-device-pixel-ratio: 2), only screen and (min-resolution: 192dpi), only screen and (min-resolution: 2dppx) {\n  mat-card {\n    margin: 5px auto;\n    padding: 35px 0; } }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/login/login.component.scss
// module id = 1520
// module chunks = 0